export default "__VITE_ASSET__CNYZy5kK__"